import pawanputraLogo from 'assets/images/logo/Pawanputra-logo-new.png';

export type ClientBranding = {
  appName: string;
  companyName: string;
  logo: string;
  footerLogo: string;
  lableBottomLogo: boolean;
  sidebarLogoExpanded: string;
  sidebarLogoCollapsed: string;
  logoDark?: string;
  sidebarLogoExpandedDark?: string;
  favicon: string;
};

export type ClientInvoice = {
  legalCompanyName: string;
  gstNumber: string;
  registeredOffice: string;
  supportContact: string;
};

export type ClientConfig = {
  clientKey: string;
  branding: ClientBranding;
  invoice: ClientInvoice;
  paymentGateway: string;
  wocomAppName: string;
  shopifyURL: string;
};

const defaultLogo = pawanputraLogo;
const defaultFavicon = '/favicon.svg';

export const clientConfigObj: Record<string, ClientConfig> = {
  pawanputra: {
    clientKey: 'pawanputra',
    branding: {
      appName: 'Pawanputra Courier and Logistics',
      companyName: 'Pawanputra Courier and Logistics',
      logo: defaultLogo,
      footerLogo: defaultLogo,
      lableBottomLogo: true,
      sidebarLogoExpanded: defaultLogo,
      sidebarLogoCollapsed: defaultLogo,
      favicon: defaultFavicon
    },
    invoice: {
      legalCompanyName: 'Pawanputra Courier and Logistics',
      gstNumber: '',
      registeredOffice: '',
      supportContact: ''
    },
    paymentGateway: '',
    wocomAppName: '',
    shopifyURL: ''
  },
  jpglogistics: {
    clientKey: 'jpglogistics',
    branding: {
      appName: 'JPG Logistics',
      companyName: 'JPG Logistics',
      logo: defaultLogo,
      footerLogo: defaultLogo,
      lableBottomLogo: true,
      sidebarLogoExpanded: defaultLogo,
      sidebarLogoCollapsed: defaultLogo,
      favicon: defaultFavicon
    },
    invoice: {
      legalCompanyName: 'JPG Logistics',
      gstNumber: '',
      registeredOffice: '',
      supportContact: ''
    },
    paymentGateway: '',
    wocomAppName: '',
    shopifyURL: ''
  },
  cargodham: {
    clientKey: 'cargodham',
    branding: {
      appName: 'CargoDham',
      companyName: 'CargoDham',
      logo: defaultLogo,
      footerLogo: defaultLogo,
      lableBottomLogo: true,
      sidebarLogoExpanded: defaultLogo,
      sidebarLogoCollapsed: defaultLogo,
      favicon: defaultFavicon
    },
    invoice: {
      legalCompanyName: 'CargoDham',
      gstNumber: '',
      registeredOffice: '',
      supportContact: ''
    },
    paymentGateway: '',
    wocomAppName: '',
    shopifyURL: ''
  },
  ronik: {
    clientKey: 'ronik',
    branding: {
      appName: 'Ronik Courier Service',
      companyName: 'Ronik Courier Service',
      logo: defaultLogo,
      footerLogo: defaultLogo,
      lableBottomLogo: true,
      sidebarLogoExpanded: defaultLogo,
      sidebarLogoCollapsed: defaultLogo,
      favicon: defaultFavicon
    },
    invoice: {
      legalCompanyName: 'Ronik Courier Service',
      gstNumber: '',
      registeredOffice: '',
      supportContact: ''
    },
    paymentGateway: '',
    wocomAppName: '',
    shopifyURL: ''
  },
  shipcave: {
    clientKey: 'shipcave',
    branding: {
      appName: 'ShipCave',
      companyName: 'ShipCave',
      logo: defaultLogo,
      footerLogo: defaultLogo,
      lableBottomLogo: true,
      sidebarLogoExpanded: defaultLogo,
      sidebarLogoCollapsed: defaultLogo,
      favicon: defaultFavicon
    },
    invoice: {
      legalCompanyName: 'ShipCave',
      gstNumber: '',
      registeredOffice: '',
      supportContact: ''
    },
    paymentGateway: '',
    wocomAppName: '',
    shopifyURL: ''
  },
  shiproute: {
    clientKey: 'shiproute',
    branding: {
      appName: 'ShipRoute',
      companyName: 'ShipRoute',
      logo: defaultLogo,
      footerLogo: defaultLogo,
      lableBottomLogo: true,
      sidebarLogoExpanded: defaultLogo,
      sidebarLogoCollapsed: defaultLogo,
      favicon: defaultFavicon
    },
    invoice: {
      legalCompanyName: 'ShipRoute',
      gstNumber: '',
      registeredOffice: '',
      supportContact: ''
    },
    paymentGateway: '',
    wocomAppName: '',
    shopifyURL: ''
  }
};

export const clientConfigPath = {
  pawanputra: '/client-configs/pawanputra.json',
  jpglogistics: '/client-configs/jpglogistics.json',
  cargodham: '/client-configs/cargodham.json',
  ronik: '/client-configs/ronik.json',
  shipcave: '/client-configs/shipcave.json',
  shiproute: '/client-configs/shiproute.json'
} as const;

export const defaultClientConfig = clientConfigObj.pawanputra;
